export const SORT_ORDERS = {
  ASC: '',
  DESC: '.desc'
}

export const defaultSize = 20
export const defaultPage = 1

export class ListItemsObject {
  constructor (rootStore) {
    this.rootStore = rootStore
  }

  resetData () {
    this.filters = {}
    this.items = null
    this.total = null
    this.page = defaultPage
    this.size = defaultSize
    this.sortFields = []
    this.selectedItem = null
  }

  filters = {}
  items = null
  total = null
  page = defaultPage
  size = defaultSize
  sortFields = []

  get pagesCount () {
    return Math.ceil(this.total / this.size)
  }

  get sortFieldNames () {
    return this.sortFields.map(sortField => sortField.name)
  }

  setSortFields (sortFields) {
    this.sortFields = sortFields
    this.getItems()
  }

  async getItems () {
    throw new Error()
  }

  setFilters (filters) {
    this.filters = filters
    this.getItems()
  }

  async setItems (data, { itemReducers = [], getItemsParameters = [] } = {}) {
    if (!data.items.length && this.page !== 1) {
      this.page = 1
      await this.getItems(...getItemsParameters)
    } else {
      let items = data.items
      const reducers = Array.isArray(itemReducers) ? itemReducers : [itemReducers]
      reducers.forEach(reducer => { items = items.map(reducer) })
      this.items = items
      this.setPaginationData(data)
    }
  }

  async changePage (page) {
    this.page = page
    await this.getItems()
  }

  async changeSize (size) {
    this.size = size
    await this.changePage(1)
  }

  setPaginationData ({ page = defaultPage, total = 0, size = defaultSize } = {}) {
    this.page = page
    this.total = total
    this.size = size
  }

  isFilledFilterField (value) {
    return Array.isArray(value) ? value.some(val => val) : value
  }

  getFilledFilterFields () {
    return Object.entries(this.filters).reduce((acc, [key, value]) => {
      if (this.isFilledFilterField(value)) { acc[key] = value }
      return acc
    }, {})
  }

  getQueryParams (filterParams = {}) {
    const queryParams = new URLSearchParams()

    const appendValueToQueryParams = (key, value) => {
      queryParams.append(key, value.toString())
    }

    Object.entries(filterParams).forEach(([key, value]) => {
      appendValueToQueryParams(key, value)
    })
    appendValueToQueryParams('size', this.size)
    appendValueToQueryParams('page', this.page)
    this.sortFields.forEach(field => {
      queryParams.append('sort_by', field.name + field.order)
    })
    return queryParams
  }
}
